import React from 'react';
import { Link } from 'react-router-dom';

const Blogs = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <div className="section-header">
          <div className="section-badge">En savoir plus pour notre blog</div>
          <h1 className="page-title">Blogs et articles</h1>
          <p className="section-description">
            Bienvenue sur le blog de CallGarden, l'endroit idéal pour trouver des astuces rapides, des conseils saisonniers et des idées fraîches pour que votre jardin soit le plus beau possible tout au long de l'année. Que vous ayez la main verte ou que vous commenciez à peine, nous avons quelque chose pour tous ceux qui aiment un bel espace extérieur.
          </p>
        </div>

        <div className="cards-grid" style={{marginTop: 'var(--spacing-xl)'}}>
          <div className="modern-card">
            <div style={{width: '100%', height: '200px', background: 'var(--color-light)', borderRadius: '12px', marginBottom: 'var(--spacing-md)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--color-gray)'}}>
              Image
            </div>
            <div style={{fontSize: '0.875rem', color: 'var(--color-gray)', marginBottom: 'var(--spacing-sm)'}}>
              Admin April 14, 2025
            </div>
            <h3 className="card-title">Bambou envahissant : techniques efficaces pour s'en débarrasser et protéger votre jardin</h3>
            <Link to="/bambou-envahissant" className="card-link">
              Read More
              <svg width="16" height="16" viewBox="0 0 512 512" fill="currentColor">
                <path d="M256 8c137 0 248 111 248 248S393 504 256 504 8 393 8 256 119 8 256 8zm-28.9 143.6l75.5 72.4H120c-13.3 0-24 10.7-24 24v16c0 13.3 10.7 24 24 24h182.6l-75.5 72.4c-9.7 9.3-9.9 24.8-.4 34.3l11 10.9c9.4 9.4 24.6 9.4 33.9 0L404.3 273c9.4-9.4 9.4-24.6 0-33.9L271.6 106.3c-9.4-9.4-24.6-9.4-33.9 0l-11 10.9c-9.5 9.6-9.3 25.1.4 34.4z"></path>
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blogs;
